function stripDiacritics(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '');
}

function isoToDDMMYYYY(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}-${m}-${y}`;
}

export function buildMedirisPatientSearchHref(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  birthDate: string | null | undefined,
): string | null {
  if (!firstName || !lastName || !birthDate) return null;
  return `https://specialist.mediris.be/Patients?action=search&firstname=${encodeURIComponent(stripDiacritics(firstName))}&lastname=${encodeURIComponent(stripDiacritics(lastName))}&birthday=${isoToDDMMYYYY(birthDate)}`;
}
